export const recaptchaMockToken = "mock-recaptcha-token";
export const recaptchaMockKey = "integration-test-recaptcha-key";

type IRecaptchaMockOptions = {
  token?: string;
  recaptchaKey?: string;
};

export const installRecaptchaMock = (options?: IRecaptchaMockOptions) => {
  const token = options?.token ?? "mock-recaptcha-token";
  const recaptchaKey = options?.recaptchaKey ?? "integration-test-recaptcha-key";

  type ConfigurationWithRecaptcha = {
    recaptchaKey?: string;
  };

  const windowWithMocks = window as Window & {
    CONFIGURATION?: ConfigurationWithRecaptcha;
    grecaptcha?: unknown;
  };

  const applyRecaptchaConfiguration = (
    configuration: ConfigurationWithRecaptcha | undefined,
  ): ConfigurationWithRecaptcha | undefined => {
    if (!configuration || typeof configuration !== "object") {
      return configuration;
    }

    const hasRecaptchaKey = typeof configuration.recaptchaKey === "string" && configuration.recaptchaKey.length > 0;

    if (!hasRecaptchaKey) {
      configuration.recaptchaKey = recaptchaKey;
    }

    return configuration;
  };

  let configurationValue = applyRecaptchaConfiguration(windowWithMocks.CONFIGURATION);

  Object.defineProperty(windowWithMocks, "CONFIGURATION", {
    configurable: true,
    get: () => configurationValue,
    set: (value: ConfigurationWithRecaptcha | undefined) => {
      configurationValue = applyRecaptchaConfiguration(value);
    },
  });

  const existingDescriptor = Object.getOwnPropertyDescriptor(windowWithMocks, "grecaptcha");
  if (existingDescriptor && existingDescriptor.configurable === false) {
    return;
  }

  const enterprise = {};
  Object.defineProperty(enterprise, "execute", {
    value: async () => token,
    configurable: false,
    writable: false,
  });
  Object.defineProperty(enterprise, "ready", {
    value: (callback: () => void) => callback(),
    configurable: false,
    writable: false,
  });
  const grecaptchaMock = {};
  Object.defineProperty(grecaptchaMock, "enterprise", {
    value: Object.freeze(enterprise),
    configurable: false,
    writable: false,
  });
  Object.defineProperty(windowWithMocks, "grecaptcha", {
    value: Object.freeze(grecaptchaMock),
    configurable: false,
    writable: false,
  });
};

export const recaptchaMockScript = `;(${installRecaptchaMock.toString()})(${JSON.stringify({
  token: recaptchaMockToken,
  recaptchaKey: recaptchaMockKey,
})});`;
